var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAgendaSubmitted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.3333,
    r: 11.5,
    fill: "#264F3F",
    stroke: "#264F3F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0136 4.33325C8.01746 4.33325 6 6.73175 6 10.2718V18.3333H9.21075V14.7135H14.8809V18.3333H18.098V10.2718C18.098 6.84198 15.9123 4.33325 12.0136 4.33325ZM9.21075 10.2025C9.16547 9.82074 9.20628 9.43365 9.33018 9.06968C9.45408 8.70572 9.65792 8.37412 9.92674 8.09924C10.1956 7.82437 10.5225 7.61319 10.8836 7.48121C11.2448 7.34924 11.6309 7.29982 12.0136 7.33658C12.3987 7.30169 12.7869 7.35185 13.1505 7.48352C13.5141 7.61519 13.8444 7.82515 14.1179 8.09855C14.3915 8.37195 14.6016 8.70212 14.7334 9.06569C14.8653 9.42926 14.9156 9.81736 14.8809 10.2025V11.7088H9.21075V10.2025Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgendaSubmitted);
export default __webpack_public_path__ + "static/media/agenda-submitted.f21bfeb5.svg";
export { ForwardRef as ReactComponent };